"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createCycleEngine = void 0;
var common_1 = require("@timeflies/common");
var delays = {
    battleStart: 8000,
    betweenTurns: 4000
};
var createCycleEngine = function (_a) {
    var charactersDurations = _a.charactersDurations, charactersList = _a.charactersList, listeners = _a.listeners;
    var disabledCharacters = new Set();
    var firstTurnStartTime = null;
    var currentTurn;
    var isCharacterDisabled = function (id) { return disabledCharacters.has(id); };
    var getEnabledCharacterIndex = function (rawIndex, roundIndex) {
        var index = charactersList
            .slice(rawIndex)
            .findIndex(function (id) { return !isCharacterDisabled(id); });
        if (index === -1) {
            return getEnabledCharacterIndex(0, roundIndex + 1);
        }
        var characterIndex = index + rawIndex;
        return {
            characterIndex: characterIndex,
            roundIndex: roundIndex
        };
    };
    var isLastCharacterEnabled = function (index) {
        return charactersList.slice(index + 1).every(isCharacterDisabled);
    };
    var playTurn = function (_a) {
        var turnIndex = _a.turnIndex, roundIndex = _a.roundIndex, characterIndex = _a.characterIndex, startTime = _a.startTime;
        return __awaiter(void 0, void 0, void 0, function () {
            var characterId, diff, duration, _b, promise, setTime, cancel, getDuration, setDuration, getEndTime;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        characterId = charactersList[characterIndex];
                        diff = common_1.getTimeDiffFromNow(startTime);
                        // if startTime is in future, wait for it
                        return [4 /*yield*/, common_1.waitMs(-diff)];
                    case 1:
                        // if startTime is in future, wait for it
                        _c.sent();
                        if (currentTurn) {
                            currentTurn.cancel();
                        }
                        duration = charactersDurations[characterId];
                        _b = common_1.waitCanceleable(duration), promise = _b.promise, setTime = _b.setTime, cancel = _b.cancel, getDuration = _b.getDuration;
                        setDuration = function (duration) {
                            setTime(duration);
                        };
                        getEndTime = function () { return startTime + getDuration(); };
                        currentTurn = {
                            turnIndex: turnIndex,
                            roundIndex: roundIndex,
                            characterIndex: characterIndex,
                            characterId: characterId,
                            startTime: startTime,
                            promise: promise,
                            setDuration: setDuration,
                            getDuration: getDuration,
                            getEndTime: getEndTime,
                            cancel: cancel
                        };
                        if (!listeners.turnStart) return [3 /*break*/, 3];
                        return [4 /*yield*/, listeners.turnStart({
                                currentTurn: {
                                    turnIndex: turnIndex,
                                    characterIndex: characterIndex,
                                    characterId: characterId,
                                    startTime: startTime,
                                    duration: getDuration(),
                                    endTime: getEndTime()
                                },
                                roundIndex: roundIndex,
                                lastRoundTurn: isLastCharacterEnabled(characterIndex)
                            })];
                    case 2:
                        _c.sent();
                        _c.label = 3;
                    case 3: return [2 /*return*/, promise.then(function (status) { return __awaiter(void 0, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!listeners.turnEnd) return [3 /*break*/, 2];
                                        return [4 /*yield*/, listeners.turnEnd({
                                                currentTurn: {
                                                    turnIndex: turnIndex,
                                                    characterIndex: characterIndex,
                                                    characterId: characterId,
                                                    startTime: startTime,
                                                    duration: getDuration(),
                                                    endTime: getEndTime(),
                                                    endTimeDelta: Date.now() - getEndTime()
                                                },
                                                roundIndex: roundIndex,
                                                lastRoundTurn: isLastCharacterEnabled(characterIndex)
                                            })];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2: return [2 /*return*/, status];
                                }
                            });
                        }); })];
                }
            });
        });
    };
    var start = function (startTime) {
        if (startTime === void 0) { startTime = Date.now() + delays.battleStart; }
        return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        firstTurnStartTime = startTime;
                        return [4 /*yield*/, playTurn(getNextTurnProps())];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    var getNextTurnProps = function () {
        // first turn
        if (!currentTurn) {
            return {
                turnIndex: 0,
                roundIndex: 0,
                characterIndex: 0,
                startTime: firstTurnStartTime
            };
        }
        var _a = getEnabledCharacterIndex(currentTurn.characterIndex + 1, currentTurn.roundIndex), characterIndex = _a.characterIndex, roundIndex = _a.roundIndex;
        return {
            turnIndex: currentTurn.turnIndex + 1,
            roundIndex: roundIndex,
            characterIndex: characterIndex,
            startTime: currentTurn.getEndTime() + delays.betweenTurns
        };
    };
    var startNextTurn = function (nextTurnProps) { return __awaiter(void 0, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!firstTurnStartTime) {
                        firstTurnStartTime = (_a = nextTurnProps === null || nextTurnProps === void 0 ? void 0 : nextTurnProps.startTime) !== null && _a !== void 0 ? _a : null;
                    }
                    return [4 /*yield*/, playTurn(nextTurnProps
                            ? nextTurnProps
                            : getNextTurnProps())];
                case 1:
                    _b.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var getNextTurnInfos = function () {
        var _a = getNextTurnProps(), roundIndex = _a.roundIndex, turnIndex = _a.turnIndex, characterIndex = _a.characterIndex, startTime = _a.startTime;
        return {
            roundIndex: roundIndex,
            turnIndex: turnIndex,
            characterId: charactersList[characterIndex],
            startTime: startTime
        };
    };
    var disableCharacters = function (idList) {
        idList.forEach(function (id) { return disabledCharacters.add(id); });
        if (currentTurn && disabledCharacters.has(currentTurn.characterId)) {
            currentTurn.cancel();
        }
    };
    var setCharacterDuration = function (newCharactersDurations) {
        charactersDurations = __assign(__assign({}, charactersDurations), newCharactersDurations);
        if (currentTurn && newCharactersDurations[currentTurn.characterId] !== undefined) {
            currentTurn.setDuration(newCharactersDurations[currentTurn.characterId]);
        }
    };
    var setTurnsOrder = function (newCharactersList) {
        if (!currentTurn || !isLastCharacterEnabled(currentTurn.characterIndex)) {
            throw new Error("Cycle setTurnsOrder should be call after last character turn [" + (currentTurn === null || currentTurn === void 0 ? void 0 : currentTurn.characterIndex) + "/" + (charactersList.length - 1) + "]");
        }
        charactersList = newCharactersList;
    };
    var stop = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!currentTurn) return [3 /*break*/, 2];
                    currentTurn.cancel();
                    return [4 /*yield*/, currentTurn.promise];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    var isStarted = function () { return firstTurnStartTime !== null; };
    return {
        start: start,
        stop: stop,
        startNextTurn: startNextTurn,
        getNextTurnInfos: getNextTurnInfos,
        setCharacterDuration: setCharacterDuration,
        disableCharacters: disableCharacters,
        setTurnsOrder: setTurnsOrder,
        isStarted: isStarted
    };
};
exports.createCycleEngine = createCycleEngine;
